import type React from "react"
import { useTranslation } from "react-i18next"
import { Link as RouterLink } from "react-router"

import { RootPath } from "@/models/route"

import { Box, Button, Typography } from "@mui/material"

export const ResetPasswordInvalid: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          mb: 4,
        }}
      >
        {t("resetPassword.invalidUrlMessage")}
      </Typography>
      <Button
        color="primary"
        component={RouterLink}
        to={`/${RootPath.ForgotPassword}`}
        variant="contained"
      >
        {t("resetPassword.forgotPasswordButton")}
      </Button>
    </Box>
  )
}
